import { Tooltip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import { StyledCell } from 'components/base/Table/Table.styles';

const DeleteCell = ({ onDelete }) => {
  return (
    <StyledCell>
      <Tooltip title='Delete'>
        <Icon name='Delete' color='shark' size='small' onClick={onDelete} />
      </Tooltip>
    </StyledCell>
  );
};

export default DeleteCell;
